module.exports = __webpack_public_path__ + "img/FR10278.1d331faa.png";